import React from 'react'
import styles from './CloseModalButton.module.css';
import { Button } from 'antd';

const CloseModalButton = (props) => {
    return (
        <div className={`${styles.CancelIconContainer} ${props.isCloseIcon ? styles.CloseIcon: ""} flex-row-reverse flex-items-center`}>
            <Button className="button-red" onClick={props.close}>
                <i className="far fa-times"></i>
            </Button>
        </div>
    )
}

export default CloseModalButton